import { render, staticRenderFns } from "./EmployeeJourney.vue?vue&type=template&id=788da008&scoped=true&"
import script from "./EmployeeJourney.vue?vue&type=script&lang=js&"
export * from "./EmployeeJourney.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeJourney.vue?vue&type=style&index=0&id=788da008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788da008",
  null
  
)

export default component.exports